import React from 'react';
import { useAuth } from '../hooks/useAuth';

export const PermissionGate = ({ requiredPermission, children, fallback = null }) => {
  const { user } = useAuth();

  if (!user?.permissions?.includes(requiredPermission)) {
    return fallback;
  }

  return children;
};
